export const ZAPIER_APP_BASE_URL = process.env.ZAPIER_APP_BASE_URL || '';

export const ZAP_EDITOR_URL =
  'https://docs.api.zapier.com/partner-solutions/workflow-api/embed-zap-editor';

// Zapier's main account ID is the same for staging and production
export const ZAPIER_ACCOUNT_ID = 2074697;
